<div class="pkt-form-field" [class.pkt-error-state]="hasError || !!errorMessage" [class.pkt-disabled]="disabled">
  <div class="pkt-label-row">
    <label *ngIf="label" class="pkt-label" [class.pkt-label--clamp]="labelLines" [style.--pkt-label-lines]="labelLines">
      {{ label }}<span *ngIf="required" class="pkt-required">*</span>
    </label>
    <span *ngIf="showCharCount" class="pkt-char-count">
      {{ charCount }}<ng-container *ngIf="maxLength"> / {{ maxLength }}</ng-container>
    </span>
  </div>

  <textarea #textareaEl class="pkt-textarea" [placeholder]="placeholder" [disabled]="disabled"
    [attr.readonly]="readonly || null" [rows]="rows" [attr.maxlength]="maxLength || null" [value]="value"
    (input)="onInputChange($event)" (blur)="onBlur()"></textarea>

  <div *ngIf="hint && !errorMessage" class="pkt-hint">{{ hint }}</div>
  <div *ngIf="errorMessage && errorDisplay === 'inline'" class="pkt-error-msg">
    <span class="material-symbols-outlined">error</span>{{ errorMessage }}
  </div>
  <div *ngIf="errorMessage && errorDisplay === 'floating'" class="pkt-error-floating" role="alert">
    <span class="material-symbols-outlined">error</span>{{ errorMessage }}
  </div>
</div>